import {CampaignRequestModel} from 'src/app/modules/campaigns/models/campaign-request.model';

export class UpdateAccount {
  static readonly type = '[Session] Update Account';
}

export class ClearState {
  static readonly type = '[Session] Clear State';
}

export class UpdateBillingSchemes {
  static readonly type = '[Session] Update Billing Schemes';
}

export class FetchCampaignPrices {
  static readonly type = '[Session] Fetch Campaign Prices';
}

export class UpsertCampaignPricing {
  static readonly type = '[Session] Upsert Campaign Pricing';
  constructor(public data: CampaignRequestModel, public priceId?: number) {}
}
